// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_RemoverDeviceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/devices_franquias/remover_device/<id>
 *
 * Action endpoint — emits a success message confirming the device was
 * removed.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface DevicesFranquias_RemoverDeviceResponseDados {
message: string
}

export type DevicesFranquias_RemoverDeviceResponse = ApiResponse<DevicesFranquias_RemoverDeviceResponseDados>;

registerResponseContract('DevicesFranquias_RemoverDeviceResponse', {
  message: { type: 'string',  required: true },
})
